import PropTypes from 'prop-types';
import React from 'react';

import Grid from '@glass/web/components/base/Unstable_Grid2';

function ContentGridItem({ children }) {
  return (
    <Grid lg={3} md={4} sm={6} xs={12}>
      {children}
    </Grid>
  );
}

ContentGridItem.propTypes = {
  children: PropTypes.node.isRequired,
};

ContentGridItem.displayName = 'ContentGridItem';

export default React.memo(ContentGridItem);
